export default {
  computed: {
    inAppView() {
      return this.$route?.query?.in_app_view === 'true';
    },
  },
};
